<div *ngIf="currentToast" [ngClass]="currentToastClass" (mouseenter)="onFocus()" (mouseleave)="onFocusOut()">
    <svg
        *ngIf="currentToast.icon as toastIcon"
        sh-icon
        [name]="toastIcon"
        aria-hidden="true"
        class="sh-toast__icon"
        [ngClass]="{'-sh-spin': currentToast.iconRotate}"
    ></svg>
    <p class="sh-toast__content">
        <sh-html-parser [message]="currentToast.message"></sh-html-parser>
    </p>
    <a *ngIf="currentToast.navigationLink && currentToast.linkText" [shNavigationLink]="currentToast.navigationLink" class="sh-link sh-toast__link">
        {{ currentToast.linkText }}
    </a>
    <button *ngIf="currentToast.closable" type="button" class="sh-pure-icon-button sh-toast__close-button" aria-label="close" (click)="closeToast($event)">
        <svg sh-icon name="close" aria-hidden="true" class="sh-icon-button__icon"></svg>
    </button>
</div>
